// @flow
import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';

import { ICONS } from 'Components/utils/icon/icons';

import { Button } from 'Components/frameworks/button/Button.jsx';
import Image from 'Components/frameworks/image/Image.jsx';

import { themes } from './MoreResults.themes';

const PLACEHOLDER_URLS = [
  'http://ns.clubmed.com/it/2019/shop/dummy.png',
  'http://ns.clubmed.com/it/2019/shop/dummy2.png',
  'http://ns.clubmed.com/it/2019/shop/dummy3.png',
];

export type MoreResultsProps = {
  className?: string,
  isLoading?: boolean,
  onClick?: (SyntheticEvent<>) => mixed,
  number: number,
  text?: string,
  theme?: string,
  grid?: string,
  maxPlaceholders: number,
};

export function MoreResults(props: MoreResultsProps) {
  const {
    className,
    isLoading,
    number = 0,
    onClick = noop,
    text,
    theme = 'default',
    grid,
    maxPlaceholders,
  } = props;

  if (!number) return null;

  const { thContent, thButton, thPlaceholders, thRoot } = themes[theme];

  const renderPlaceholders = () => {
    const placeholders = [];
    for (let i = 0; i < number && i < maxPlaceholders; i++) {
      placeholders.push(
        <Image
          className={classnames('fadeIn px-2 align-bottom', grid)}
          imageUrl={PLACEHOLDER_URLS[i]}
          mandatoryWidthAndHeight={{ w: 760, h: 'auto' }}
          key={PLACEHOLDER_URLS[i]}
        />,
      );
    }
    return placeholders;
  };

  return (
    <div className={classnames(className, thRoot)}>
      <div className={thContent}>
        <div className={thPlaceholders}>
          {renderPlaceholders()}
          <div
            style={{
              position: 'absolute',
              bottom: '0',
              left: '0',
              right: '0',
              top: '0',
              background:
                'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)',
            }}
          />
        </div>
        <div className={thButton}>
          <Button
            onClick={onClick}
            iconRight={{ name: ICONS.BOLDER_ARROW_FORTH }}
            minWidth="220px"
            isLoading={isLoading}
          >
            <span data-testid="Moreresults-number">{number}</span> {text}
          </Button>
        </div>
      </div>
    </div>
  );
}
